export const MATERIAL_EXPORT_ID = 'material';

export const MATERIAL_EXPORT_TITLE = 'Materiales';

export const LOCALIZED_PROPERTIES = {
  externalKeys: 'Código',
  barcode: 'Código de barra',
  name: 'Nombre',
  reference: 'Referencia',
  descriptionLong: 'Descripción larga',
  descriptionShort: 'Descripción corta',
  price: 'Precio',
  company: 'Compañía',
  division: 'División',
  materialBrand: 'Marca del material',
  materialGroups: 'Grupos del material',
  materialImage: 'Imagen',
  type: 'Tipo de material',
  baseUnitOfMeasure: 'Unidad de Medida Base',
  canMakeAnOrderWithoutStock: 'Ventas sin inventario',
  status: 'Estado',
};
